module.exports = __webpack_public_path__ + "static/media/downloadIcon.3ebb1986.svg";